const MULTIPLIER = 1664525;
const INCREMENT = 1013904223;
const UINT_MAX = 0xffffffff;

export function nextRngState(seed: number): number {
  return (seed * MULTIPLIER + INCREMENT) >>> 0;
}

export function rngUnit(seed: number): { readonly state: number; readonly value: number } {
  const state = nextRngState(seed);
  return { state, value: state / UINT_MAX };
}
